<template>
    <div class="settings__page">
        <SectionHeader :icon="`icon-settings`">
            {{$t('settings') | upperCase}}
        </SectionHeader>
        <div class="settings__container">
            <div class="left-container">
                <div class="section">
                    <div class="section-title">{{ $t('your profile details') | capitalize }}</div>

                    <div class="data-row">
                        <div class="data-field">
                            <div class="label">{{ $t('username') | capitalize }}</div>
                            <div class="value">{{ user.username }}</div>
                        </div>
                    </div>

                    <div class="data-row">
                        <div class="data-field">
                            <PhoneUpdateContainer class="data-field phone"/>
                        </div>
                        <div class="data-field">
                            <div class="label">{{ $t('E-mail') }}</div>
                            <div class="value">{{ user.email }}</div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="right-container">
                <div class="section">
                    <div class="section-title">{{ $t('privacy policy') | capitalize }}</div>
                    <GdprShowUpdateContainer/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import PhoneUpdateContainer from './PhoneUpdateContainer.vue';
    import GdprShowUpdateContainer from './GdprShowUpdateContainer.vue';

    export default {
        name: 'SettingsContainer',
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
        },
        components: {
            PhoneUpdateContainer,
            GdprShowUpdateContainer
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/settings/SettingsContainer.vue